<template>
    <div class="gh-page gh-page-suicide-prevention" sticky-container>
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in">
            <!-- <gh-confirmation v-if="isRegistrationSuccess"/> -->

            <div>
                <gh-banner/>
                <gh-cta/>
                <gh-purpose/>
                <gh-suicide-facts />
                <gh-snapshots @tncToggle="dialogVisible = !dialogVisible"/>
                <gh-speakers/>
                <gh-testimonials :key="componentKey"/>
                <gh-schedule/>
                <gh-requirements/>
                <gh-commit-to-charity id="social-impact" />
                <!-- <gh-events-partners/> -->
                <gh-form-registration @tncToggle="dialogVisible = !dialogVisible"/> 
                <!-- <gh-form-registration :event-id="11" @tncToggle="dialogVisible = !dialogVisible"/> -->

                <!-- <gh-registration-closed/> -->
                <gh-faqs/>
                <gh-sponsors/>
                <gh-term :visible="dialogVisible" :width="dialogWidth" @hide="dialogVisible = false"/>

            </div>
        </transition>
        <gh-go-to-registration/>
    </div>
</template>

<script>
    import ghBanner from '@/modules/events/suicidePreventionSummit/components/Banner'
    import ghCta from '@/modules/events/suicidePreventionSummit/components/CTA'
    import ghPurpose from '@/modules/events/suicidePreventionSummit/components/Purpose'
    import ghSuicideFacts from '@/modules/events/suicidePreventionSummit/components/SuicideFacts'
    import ghSnapshots from '@/modules/events/suicidePreventionSummit/components/Snapshots'
    import ghSpeakers from '@/modules/events/suicidePreventionSummit/components/Speakers'
    import ghUnprecedented from '@/modules/events/suicidePreventionSummit/components/Unprecedented'
    import ghRequirements from '@/modules/events/suicidePreventionSummit/components/Requirements'
    import ghSchedule from '@/modules/events/suicidePreventionSummit/components/Schedule'
    import ghFormRegistration from '@/modules/events/suicidePreventionSummit/components/FormRegistration'
    import ghFaqs from '@/modules/events/suicidePreventionSummit/components/Faqs'
    import ghSponsors from '@/modules/events/suicidePreventionSummit/components/Sponsors'
    // import ghConfirmation from '@/modules/events/suicidePreventionSummit/components/Confirmation'
    // import ghRegistrationClosed from '@/modules/events/suicidePreventionSummit/components/RegistrationClosed'
    import ghGoToRegistration from '@/modules/events/suicidePreventionSummit/components/MobileGoToRegistration'
    import ghTestimonials from '@/modules/events/suicidePreventionSummit/components/Testimonials'
    import ghCommitToCharity from '@/modules/events/suicidePreventionSummit/components/CommitToCharity'
    import ghEventsPartners from '@/modules/events/suicidePreventionSummit/components/EventPartners'
    import ghTerm from '@/modules/events/suicidePreventionSummit/components/Term'
    import UX from '@/utils/ux';

    export default {
        components: {
            ghBanner,
            ghCta,
            ghSnapshots,
            ghSpeakers,
            ghUnprecedented,
            ghRequirements,
            ghPurpose,
            ghSchedule,
            ghFormRegistration,
            ghFaqs,
            ghSponsors,
            // ghConfirmation,
            // ghRegistrationClosed,
            ghSuicideFacts,
            ghGoToRegistration,
            ghTestimonials,
            ghCommitToCharity,
            ghEventsPartners,
            ghTerm,
        },

        data() {
            return {
                eventId: 4,
                dialogVisible: false,
            }
        },

        created () {
            this.fetchFaqs()
            this.fetchSpeakers()
            this.fetchSessions()
            // this.fetchSponsors()
        },

         methods: {
            scrollToSection(section) {
                const element = document.querySelector(section);
                element && UX.scrollTo(element);
            },

            fetchFaqs () {
                this.$store.dispatch('event/getFaqs', this.eventId)
            },

            fetchSpeakers () {
                this.$store.dispatch('event/getSpeakers', this.eventId)
            },

            fetchSessions () {
                this.$store.dispatch('event/getSessions', this.eventId)
            },

            // fetchSponsors () {
            //     this.$store.dispatch('event/getSponsors', this.eventId)
            // }
        },

        computed: {
            // isRegistrationSuccess() {
            //     return this.$store.state.event.registrationSuccess;
            // }, 
            device() {
                return this.$store.getters['ui/getDevice'];
            },
            dialogWidth() {
                return this.device !== 'widescreen' ? '85%' : '50%'
            }
        },

        mounted() {
            if(this.$route.hash) {
                this.scrollToSection(this.$route.hash)
            }
        },
        // watch: {
        //     isRegistrationSuccess(state) {
        //         if (state) {
        //             window.scrollTo(0, 0);
        //         }
        //     }
        // }
    }
</script>
<style lang="scss">
    @import url("https://use.typekit.net/hrd6pow.css");

    %typography-heading {
        font-family: freight-sans-pro, sans-serif;
        font-weight: 600;
        font-style: normal;
    }

    %typography-body {
        font-family: freight-sans-pro, sans-serif;
        font-weight: 500;
        font-style: normal;
    }


    $cyan : #4ba6f5;

    a {
        font-family: freight-sans-pro,sans-serif；
    }

    body {
        @extend %typography-body;
    }
    .karla {
        font-family: 'Karla', sans-serif;
    }

    .freight-heading {
        font-family: freight-sans-pro, sans-serif;
        font-weight: 600;
        font-style: normal;
    }
    body, .freight-text {
        font-family: freight-sans-pro, sans-serif;
        font-weight: 400;
        font-style: normal;
        background-color: white;
    }

    .gh-page-suicide-prevention, #gh-summit-header {
        .container {
            padding: 20px;
            width: 100%;
            @media only screen and (min-width: 64em) {
                width: 64em;
            }

            @media only screen and (min-width: 75em) {
                width: 1240px;
                
            }

            @media only screen and (min-width: 75em) {
                width: 1240px;
            }
        }

        .gh-go-to-rego {
            right: 4rem;
            padding: 3px 1rem !important;
            left: unset !important;
        }

        .gh-section {
            padding: 2.5rem 0;
            @media (max-width: 767px) {
            padding: 3rem 1rem;
            }
        }

        

        .gh-section-heading {
            text-align: center;
            font-weight: bold;
            padding-bottom: 2.5rem;
            line-height: .7;
            font-size: 2.5rem;
            @media (max-width: 767px) {
                font-size: 2rem;
                line-height: 1;
            }
        }

        .gh-center {
            text-align: center;
        }

        .gh-white {
            color: white;
        }

        .gh-bg-white {
            background-color: white;
        }

        .gh-blue {
            color: #001e41;
        }

        .gh-bg-blue {
            background-color: #001e41;
        }

        .gh-cyan {
            color: $cyan;
        }

        .gh-bg-cyan {
            background-color: #c6e4f2;
        }

        .gh-red {
            color: #f34235;
        }

        .gh-bg-red {
            background-color: #f34235;
        }

        .gh-yellow {
            color: #fdca30;
        }

        .gh-bg-yellow {
            background-color: #fdca30;
        }

        .gh-darkgrey {
            color: #0C0C0E;
        }

        .gh-grey {
            color: #474f59;
        }

        .gh-lightgrey {
            color: #f7f7f7;
        }

        .gh-medgrey {
            color: #B5B9BD;
        }

        .gh-bg-lightgrey {
            background-color: #f7f7f7;
        }

        .gh-bold {
            font-weight: bold !important;
        }

        .gh-border-cyan {
            border-color:$cyan;
        }

        .gh-lightBlue {
        color: #374785;
        }

        .gh-bg-skyBlue {
        background-color: #E8EFF8;
        }

        .gh-lightPink {
        color: #F76C6C;
        }


        sup {
            font-size: 1rem;
        }

        .gh-button-register {
            font-weight:600;
            transition: .3s;
            color: white;
            padding: 13px 30px;
            font-size: 1rem;
            border-radius: 5px;
            transition: .3s;
            &:hover {
                background-color: #0e3e75;
            }
        }
    }
</style>
